import { Injectable } from "@angular/core"
import {  Resolve} from "@angular/router"
import {catchError, of} from "rxjs"
import { AuthenticationService } from "../authentication.service";
@Injectable()

export class RouteResolver implements Resolve<any>{

    constructor(private auth:AuthenticationService ){

    }
    async resolve() {
        let obj={}
        if(sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null){
            return null
        }else{
            let a =await this.auth.getErpUser(obj)
            return  a
        }
        // .pipe(
        //     catchError(error =>{
        //         return of({error:"API failed"})
        //     })
        // );
    }
}